import React from "react";
import lazyPage from "../../../../../common/helpers/lazyPage";
import LoadingFrame from "../../../LoadingFrame";
export default lazyPage(
    "src/front/components/Task/types/BarSorting2/barsorting2.tsx",
    () => import("./barsorting2"),
    <LoadingFrame />,
);
